import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTemplates2GetDefaults } from "@/lib/api/requests/templates.requests";
import { DefaultTemplateType } from "@/page-components/post-generator/template-editor/registry/defaultTemplates";

interface UseDefaultTemplateProps {
    prefillData?: {
        entityType: string;
        entityId: string;
    };
    enabled?: boolean;
}

export const useDefaultTemplate = ({ prefillData, enabled = true }: UseDefaultTemplateProps = {}) => {
    const navigate = useNavigate();
    
    const { data: defaults, isLoading } = useTemplates2GetDefaults({ enabled });

    const [missingTemplateType, setMissingTemplateType] = useState<DefaultTemplateType | null>(null);
    const [missingTemplateLabel, setMissingTemplateLabel] = useState<string>("");

    const handleCreatePost = (type: DefaultTemplateType, label?: string, e?: React.MouseEvent) => {
        e?.stopPropagation();
        
        const templateId = defaults?.[type];
        
        if (templateId) {
            const params = new URLSearchParams();
            params.set('templateId', templateId);
            if (prefillData) {
                params.set('prefillEntityType', prefillData.entityType);
                params.set('prefillEntityId', prefillData.entityId);
            }
            navigate(`/post-generator/create-post?${params.toString()}`);
        } else {
            setMissingTemplateType(type);
            if (label) setMissingTemplateLabel(label);
        }
    };

    const isAssigned = (type: DefaultTemplateType) => !!defaults?.[type];

    return {
        isLoading,
        handleCreatePost,
        isAssigned,
        missingTemplateDialogProps: {
            open: !!missingTemplateType,
            onOpenChange: (open: boolean) => !open && setMissingTemplateType(null),
            type: missingTemplateType || DefaultTemplateType.BIRTHDAY, // Fallback to avoid null
            label: missingTemplateLabel
        }
    };
};
